<template>
	<article class="placeholder-manage">
		<managing-section>
			<managing-box title="리뷰 작성 화면">
				<textarea v-model="placeHolderText"></textarea>
				<p class="placeholder-manage__desc">
					※ 저장된 내용은 10분 후 반영됩니다.
				</p>
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button class="btn-main blue" type="button" @click="saving">
				저장하기
			</button>
			<button class="btn-main" type="button" @click="rewrite">
				다시작성
			</button>
		</div>
	</article>
</template>

<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';

	export default {
		name: 'PlaceholderManage',
		components: { ManagingSection, ManagingBox },
		data() {
			return {
				placeHolderText: '',
				originText: '',
			};
		},
		created() {
			this.getPlaceholderText();
		},
		methods: {
			async getPlaceholderText() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						'/api/operation/placeholder'
					);
					this.placeHolderText = data.text;
					this.originText = data.text;
				} catch (err) {
					console.error(err);
					alert(
						'플레이스홀더를 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async saving() {
				if (!confirm('정말 등록하시겠습니까?')) return;
				try {
					const params = { placeHolderText: this.placeHolderText };
					await this.$axiosAdmin2.put(
						`/api/operation/placeholder`,
						params
					);
					window.location.reload();
				} catch (err) {
					console.error(err);
					alert(
						'플레이스홀더를 저장하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			rewrite() {
				this.placeHolderText = this.originText;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.placeholder-manage__desc {
		margin-top: 12px;
		color: $red;
		font-weight: 700;
	}
</style>
